import classNames from "classnames";

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PropTypes from "prop-types";

import React from "react";

export default class Loading extends React.Component {
  static displayName = "Loading";

  static propTypes = {
    text: PropTypes.string,
    size: PropTypes.oneOf(["small"]),
    position: PropTypes.oneOf(["top", "bottom", "center"]),
  };

  static defaultProps = { position: "center" };

  render() {
    return (
      <div className={classNames("et--loading", this.props.className)}>
        <div
          className={classNames("et--loading--wrapper", {
            "is-center": this.props.position === "center",
            "is-top": this.props.position === "top",
            "is-bottom": this.props.position === "bottom",
            "loading--wrapper-small": this.props.size === "small",
          })}
        >
          <div
            className={classNames("et--loading--spinner", {
              "et--loading--spinner-small": this.props.size === "small",
            })}
          />
          {this.props.text ? (
            <div className="et--loading--text">{this.props.text}</div>
          ) : (
            <div className="et--visually-hidden" aria-live="polite">
              Data is loading
            </div>
          )}
        </div>
      </div>
    );
  }
}
